import { isEmpty } from 'es-toolkit/compat';

export const CONTINUOUS_REVIEW_TYPES = {
  JOIN_DATE: 'JOIN_DATE',
  ANNIVERSARY: 'ANNIVERSARY',
  PROBATION_CHECKIN: 'PROBATION_CHECKIN',
  REVIEW_OUTCOME: 'REVIEW_OUTCOME',
};

export const REVIEW_PRESET_TYPES = {
  ANNUAL_APPRAISAL: 'ANNUAL_APPRAISAL',
  QUARTERLY_REVIEW: 'QUARTERLY_REVIEW',
  PIP_REVIEW: 'PIP_REVIEW',
  // COMPETENCY_ASSESSMENT: 'COMPETENCY_ASSESSMENT',
  CUSTOM: 'CUSTOM',

  PROBATION_REVIEW: 'PROBATION_REVIEW',
  // demo preset types
  WORK_ANNIVERSARY_REVIEW: 'WORK_ANNIVERSARY_REVIEW',
  PROBATION_30_60_90: 'PROBATION_30_60_90',
};

export const REVIEW_CREATION_TYPES = {
  DEFAULT: 'DEFAULT',
  TRIGGERED: 'TRIGGERED',
};

export const REVIEW_TYPE_OPTIONS = [
  { label: 'One time', value: REVIEW_CREATION_TYPES.DEFAULT },
  { label: 'Continuous (based on triggers)', value: REVIEW_CREATION_TYPES.TRIGGERED },
];

export const REVIEW_RESPONSE_PROVIDER_TYPE_WITH_REMINDER = ['SELF', 'MANAGER', 'PEER', 'UPWARD', 'DLM'];

export const REVIEW_TIMELINE_STAGES = {
  SELF: 'SELF',
  MANAGER: 'MANAGER',
  PEER: 'PEER',
  UPWARD: 'UPWARD',
  NOMINATOR: 'NOMINATOR',
  RATING_CALIBRATE: 'RATING_CALIBRATE',
  DLM: 'DLM',

  // FOR CONTINUOUS TYPE REVIEW ONLY
  AUTO_PUBLISH: 'AUTO_PUBLISH',
};

export const getAllSectionsInOrder = ({
  reviewType = null,
  enabledProviderTypes,
  timelineProviderTypes,
  isAutoPublish = false,
}) => {
  let sections = [];

  // timeline or enableProviders data hasn't been loaded yet
  if (isEmpty(timelineProviderTypes) || enabledProviderTypes.length === 0 || !reviewType) {
    return sections;
  }
  // nomination comes first if enabled
  if (timelineProviderTypes.NOMINATOR) {
    sections.push('NOMINATOR');
  }
  // then all enabled provider types in order
  sections = [...sections, ...enabledProviderTypes];

  // then calibration if enabled
  if (timelineProviderTypes.RATING_CALIBRATE) {
    sections.push('RATING_CALIBRATE');
  }
  // then auto publish if continuous and enabled
  if (reviewType === REVIEW_CREATION_TYPES.TRIGGERED && isAutoPublish) {
    sections.push(REVIEW_TIMELINE_STAGES.AUTO_PUBLISH);
  }
  return sections;
};
